module.exports = __webpack_public_path__ + "static/media/history.7448fe51.png";